// extracted by mini-css-extract-plugin
export default {"list":"Introduction_list__hOH9Z"};